import { render, staticRenderFns } from "./BookCentreProducts.vue?vue&type=template&id=c67ac6a6&"
import script from "./BookCentreProducts.vue?vue&type=script&lang=js&"
export * from "./BookCentreProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports